export { default } from './SpotMarkerTooltip';
